/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const CandlestickIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M17.5 3a1 1 0 1 0-2 0v2.5H15a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h.5v2.6a1 1 0 1 0 2 0v-2.6h.5a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-.5zm-9 2a1 1 0 0 0-2 0v2.5H6a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h.5v2.6a1 1 0 1 0 2 0v-2.6H9a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-.5z" clipRule="evenodd" /></svg>;
};
export default CandlestickIcon;